//import {test_function} from "./../functions/test_function.js";



import {getId} from "./../universal_methods/getId.js";  
import {setId} from "./../universal_methods/setId.js";
import {isEmpty} from "./../universal_methods/isEmpty.js";  
import {getAttributes} from "./../universal_methods/getAttributes.js";  






import {render} from "./methods/render.js";
import {events} from "./methods/events.js";
import {show} from "./methods/show.js";
import {hide} from "./methods/hide.js";
import {showWithCustomContent} from "./methods/showWithCustomContent.js";




//import "./styles/_main.scss";



export class SmetioOverlayPreloader{
    
    constructor(){
        

        this.getId = getId;
        this.setId = setId;     
        this.isEmpty = isEmpty;
        this.getAttributes = getAttributes;
    

        this.setId();

        this.render = render;
        this.events = events;
        this.show = show;
        this.hide = hide;
        this.showWithCustomContent = showWithCustomContent;

        this.text = "Loading...";
        this.lightboxStyle = "";

        this.mainContent = `

            <div class="smetio-overlayPreloader-spinner">

                <p>${this.text}</p>

                <i class="smetio-icon smetio-icon-spinner smetio-spin"></i>

            </div>

        `;

        this.customContent = "";

        this.mainClass = "smetio-overlayPreloader-"+this.id;
        this.mainAttributes = {
            
            class: [
                
                "smetio-overlayPreloader",
            
                this.mainClass
            ],
        }; 
        this.mainAttributes["data-smetio-isVisible"] = "no";
        

        


    };
    

};
